import { isWindows, isChrome, isChromium, isEdge } from 'react-device-detect';

const WINDOWS_MAILTO_LENGTH_LIMIT = 2000;

export const isAbleToSendNotificationEmail = (uri: string): boolean => {
  const isWindowsAndChromiumBased = isWindows && (isChrome || isChromium || isEdge);

  return !(isWindowsAndChromiumBased && uri.length > WINDOWS_MAILTO_LENGTH_LIMIT);
};

export const getEncodedMailtoTemplate = (
  email: string,
  content: string,
  subject: string
): string => {
  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(content)}`;
};
